//@ts-check
import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import useUpdateConsent from '../../../../../../actions/entitlementApi/selectors/useUpdateConsent';
import { useStore } from '../../../../store';
import { WORKFLOWS } from './IntegrationDetails';

const IMS_PARAMS = {
  ID_TOKEN: 'id_token',
  STATE_TOKEN: 'state',
  ADMIN_CONSENT: 'admin_consent',
  SCOPE: 'scope',
  ERROR: 'error',
};

const useValidateConsentStatus = () => {
  const { appId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const updateConsent = useUpdateConsent();
  const [calledUpdateConsent, setCalledUpdateConsent] = useState(false);
  const isAdmin = useStore((state) => state.selectedOrg?.role === 'ADMIN');

  const clickedOnAllow = searchParams.get(IMS_PARAMS.ADMIN_CONSENT) === 'true';
  const shouldValidateConsent = isAdmin && clickedOnAllow && !calledUpdateConsent;
  const isValidatingConsent = updateConsent.isLoading || shouldValidateConsent;

  // Validate the consent status when the user comes back from the IMS browser based workflow.
  useEffect(() => {
    (async () => {
      const newSearchParams = new URLSearchParams(searchParams);
      if (shouldValidateConsent) {
        try {
          setCalledUpdateConsent(true);
          const idToken = searchParams.get(IMS_PARAMS.ID_TOKEN);
          const stateToken = searchParams.get(IMS_PARAMS.STATE_TOKEN);

          await updateConsent.mutateAsync({
            appType: 'S2S',
            action: 'ALLOW',
            stateToken,
            idToken,
            appId,
            showErrorToast: true,
          });
          newSearchParams.set('workflow', WORKFLOWS.ACCESS_GRANTED);
        } catch (error) {
          // Do nothing. The error will be handled by the useUpdateConsent hook.
        }
      }
      Object.values(IMS_PARAMS).forEach((key) => {
        newSearchParams.delete(key);
      });
      if (newSearchParams.toString() !== searchParams.toString()) {
        setSearchParams(newSearchParams);
      }
    })();
  }, [appId, searchParams, setSearchParams, shouldValidateConsent, updateConsent]);

  return { isValidatingConsent, updateConsent };
};

export default useValidateConsentStatus;
